import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { Collapse, Col } from 'antd';
import { flattenDocs } from '../../utils';
import { isNil } from 'lodash';

import { Download, TextField, RadioGroup } from 'components';
const { Panel } = Collapse;

const DownloadedItems = ({ content, subgroupName, docs, subdocs, subgroup, docItems }) => {

  return (
    subgroup === true && subgroupName === 'companies' ?
     subdocs.map((item, index) => {
      const flatDocsCompanies = flattenDocs(item);
      console.log({flatDocsCompanies})
      console.log({index})

      return (
        <div className='companiesCollapse mb-1'>
          <Collapse>
            <Panel header={
              <span>{item.cmpNameAff ? index + 1 + '. ' +  `Στοιχεία Συνεργαζόμενης Επιχείρησης: ` + item.cmpNameAff : '-'}</span>
            }>
              <div className='d-flex mb-2'>
                <Col span={5}>
                  <TextField label='Νομική Μορφή' bold value={item.cmpDocslegalForm} disabled/>
                </Col>
              </div>
              <div className='d-flex mb-2'>
                <Col span={6}>
                  <RadioGroup 
                    label='Μέγεθος Επιχείρησης σύμφωνα με ΥΔ ΜΜΕ' 
                    options={[
                      { label: 'Μικρή', value: 'Μικρή', disabled: false },
                      { label: 'Μεσαία', value: 'Μεσαία', disabled: false },
                      { label: 'Μεγάλη', value: 'Μεγάλη', disabled: false },
                    ]}
                    bold 
                    value={item.cmpCompanySize} 
                    disabled/>
                </Col>
              </div>
              <div className='d-flex mb-2'>
              <Col span={5}>
                  <TextField label='Είδος Λογιστικών Βιβλίων' bold value={item.cmpTypeAccountingBooks} disabled/>
                </Col>
              </div>
              <div className="file-download-container">  
                  {content.map((c, index) =>
                      includes(
                        flatDocsCompanies
                          .filter(d => d)
                          .filter(d => d.field)
                          .map(d => d.field),
                        c.fileCode
                      ) ? (
                        <Download
                          key={index}
                          description={c.label}
                          file={flatDocsCompanies.filter(d => d).filter(d => d.field === c.fileCode)}
                        />
                      ) : null
                  )}
              </div>
            </Panel>
          </Collapse>
      </div>
      )
    })  
    :
    <>
        {/* 3.2 Στοιχεία Απασχόλησης και Αποτελεσμάτων */}
        {!isNil(docItems?.typeAccountingBooks) &&
          <div className='mb-3'>          
              <Col span={14} className='mb-2'>
                <TextField label='Είδος Λογιστικών Βιβλίων ' bold value={docItems.typeAccountingBooks} disabled/>
              </Col>
          </div>
        }
        {!isNil(docItems?.contractAdmin) &&
          <div className='mt-4'>          
              <Col span={14} className='mb-2'>
              <RadioGroup 
                    label='Έχετε συνάψει σύμβαση για όρους σύνδεσης με αρμόδιο διαχειριστή (ΔΕΔΔΗΕ / ΑΔΜΗΕ);' 
                    options={[
                      { label: 'Ναι', value: 'Ναι', disabled: false },
                      { label: 'Όχι', value: 'Όχι', disabled: false },
                    ]}
                    bold 
                    value={docItems?.contractAdmin} 
                    disabled/>
              </Col>
          </div>
        }
        <div className="file-download-container">
          {content.map((c, index) =>
            includes(
              docs
                .filter(d => d)
                .filter(d => d.field)
                .map(d => d.field),
              c.fileCode
            ) ? (
              <Download
                key={index}
                description={c.label}
                file={docs.filter(d => d).filter(d => d.field === c.fileCode)}
              />
            ) : null
          )}
      </div>  
    </>
  );
};

DownloadedItems.propTypes = {
  content: PropTypes.array.isRequired,
  docs: PropTypes.array.isRequired,
};

export default DownloadedItems;
